/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
/**
 * @hidden
 */
var TextElementsVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextElementsVisualModelExport, _super);
    function TextElementsVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.e = 0;
        _this.d = 0;
        _this.c = 0;
        _this.f = 0;
        _this.g = null;
        _this.b = null;
        _this.a = null;
        return _this;
    }
    TextElementsVisualModelExport.prototype.h = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("top : " + this.e + ", ");
        a.l("left : " + this.d + ", ");
        a.l("height : " + this.c + ", ");
        a.l("width : " + this.f + ", ");
        if (this.g != null) {
            a.l("value : \"" + this.g.toString() + "\", ");
        }
        a.l("textColor : " + this.b.serialize() + ", ");
        if (this.a != null) {
            a.l("borderColor : " + this.a.serialize() + ", ");
        }
        a.l("}");
        return a.toString();
    };
    TextElementsVisualModelExport.$t = markType(TextElementsVisualModelExport, 'TextElementsVisualModelExport');
    return TextElementsVisualModelExport;
}(Base));
export { TextElementsVisualModelExport };
//# sourceMappingURL=TextElementsVisualModelExport.js.map
